import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import useClearCacheAndReload from 'features/estoque/hooks/useClearCacheAndReload';
import NotificationToast from 'components/common/NotificationToast';

/**
 * Componente reutilizável de botão para limpar cache e recarregar dados
 * 
 * @param {string} endpoint - Nome do endpoint (ex: 'oss-estoque', 'produtos-usados-os')
 * @param {Object} params - Parâmetros: {data_inicio?, data_fim?, empresa?}
 * @param {Function} onReload - Função que recarrega os dados após limpar cache
 * @param {string} className - Classes CSS adicionais
 * @param {Object} ...props - Outras props do botão
 */
const ClearCacheButton = ({ endpoint, params, onReload, className = '', ...props }) => {
  const [notification, setNotification] = useState(null);
  
  const handleSuccess = (message) => {
    setNotification({ message, type: 'success' });
  };
  
  const handleError = (message) => {
    setNotification({ message, type: 'error' });
  };
  
  const { clearCacheAndReload, loading } = useClearCacheAndReload(
    endpoint,
    params,
    onReload,
    handleSuccess,
    handleError
  );
  
  const defaultClassName = 'inline-flex items-center gap-2 rounded-md border border-[color:var(--border)] bg-[color:var(--surface-muted)] px-3 py-2 text-sm font-medium text-[color:var(--text-primary)] shadow-sm hover:bg-[color:var(--surface-muted)] focus:outline-none focus:ring-2 focus:ring-[color:var(--accent)] focus:ring-offset-2 focus:ring-offset-[color:var(--surface)] disabled:opacity-50 disabled:cursor-not-allowed';
  
  return (
    <>
      {notification && (
        <NotificationToast
          message={notification.message}
          type={notification.type}
          duration={4000}
          onClose={() => setNotification(null)}
        />
      )}
      <button
        onClick={clearCacheAndReload}
        disabled={loading}
        className={`${defaultClassName} ${className}`}
        {...props}
      >
        <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
        {loading ? 'Recarregando...' : 'Recarregar Dados'}
      </button>
    </>
  );
};

export default ClearCacheButton;

